module.exports = __webpack_public_path__ + "static/media/Program11.d444f9d0.jpg";